import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule],
  selector: 'hlp-tag',
  template: `
    @let tagInnerClass = 'tag--' + this.innerClass();

    <!--     eslint-disable-next-line @angular-eslint/template/no-inline-styles-->
    <span
      class="tag"
      [ngClass]="tagInnerClass + ' ' + customClasses()"
      [ngStyle]="{ 'background-color': backgroundColor() }"
    >
      @let iconVal = this.icon();

      @if (iconVal) {
        <mat-icon class="tw:mr-0! tw:size-4!" [ngClass]="tagInnerClass + '__icon'" [svgIcon]="iconVal" />
      }

      @if (!!label()) {
        <span>{{ label() }}</span>
      }

      <ng-content />

      @if (removable()) {
        <button class="tag__btn" (click)="removeTag.emit()" type="button">
          <mat-icon class="tag__btn__icon" svgIcon="cross" />
        </button>
      }
    </span>
  `,
  styleUrls: ['./tag.component.scss', 'status-tag.scss'],
})
export class TagComponent {
  readonly customClasses = input<string>();
  readonly innerClass = input<string>('');
  readonly label = input<string>();
  readonly removable = input<boolean>(false);
  readonly icon = input<string>();
  readonly backgroundColor = input<string>();

  removeTag = output();
}
